export type Oauth2ErrorCode =
  | 'invalid_request'
  | 'invalid_client'
  | 'invalid_grant'
  | 'unauthorized_client'
  | 'unsupported_grant_type'
  | 'invalid_scope'
  | 'server_error';

export class Oauth2Error extends Error {
  readonly errorCode: Oauth2ErrorCode;
  readonly errorDescription: string;

  constructor(errorCode: Oauth2ErrorCode, errorDescription: string) {
    super(errorDescription);
    this.name = 'Oauth2Error';
    this.errorCode = errorCode;
    this.errorDescription = errorDescription;
  }
}
